package com.solevo.dist.application.models.countries

data class CountryData(
    val isoCode: String,
    val phoneCode: String = "+381",
    val name: String = "",
    val regexPattern: String = "",
)

class CountriesData {
    companion object {
        val countries = listOf(
            CountryData("ao", "+244", "Angola", "^\\+2449[1-9][0-9]{7}$"),
            CountryData("bf", "+226", "Burkina Faso", "^\\+226(5[1256789]\\d{6}|[67]\\d{7})$"),
            CountryData("cm", "+237", "Cameroon", "^\\+237(2[2368]\\d{7}|6[2356789]\\d{7})$"),
            CountryData("ci", "+225", "Ivory Coast", "^\\+225(0[1-9]\\d{8}|[1-9]\\d{8})$"),
            CountryData("dz", "+213", "Algeria", "^(00213|\\+213|0)(5|6|7)[0-9]{8}$"),
            CountryData("gh", "+233", "Ghana", "^\\+233(2[0-9]{8}|5[0-9]{8}|3[0-9]{8})$"),
            CountryData("fr", "+33", "France", "^(?:(?:\\+|00)33|0)\\s*[1-9](?:[\\s.-]*\\d{2}){4}$"),
            CountryData("gb", "+44", "United Kingdom", "^(\\+44|0)7\\d{9}$"),
            CountryData("mg", "+261", "Madagascar", "^(\\+261|0)\\d{9}$"),
            CountryData("ro", "+40", "Romania", "^(\\+40|0)7\\d{8}$"),
            CountryData("rs", "+381", "Serbia", "^\\+3816\\d{7,8}$"),
            CountryData("sn", "+221", "Senegal", "^\\+221(3[03]\\d{7}|7[015678]\\d{7})"),
            CountryData("ch", "+41", "Switzerland", "^(\\+41|0)\\d{9}$"),
            CountryData("ml", "+223", "Mali", "^\\+223[5-9]\\d{7}$"),
            CountryData("ma", "+212", "Morocco", "^(\\+212|0)[5-7]\\d{8}$"),
            CountryData("tn", "+216", "Tunisia", "^(\\+216|0)[2-9]\\d{7}$"),
            CountryData("gm", "+220", "Gambia", "^(\\+220|0)[2-9]\\d{6}$"),
            CountryData("mr", "+222", "Mauritania", "^(\\+222|0)[2-9]\\d{7}$")
        ).sortedBy { it.name }
    }
}